import React from 'react'
import { FollowMeFeedParams, getFollowMeSharedBetsFeed } from '@core/Areas/FollowMe/helpers/api'
import { FollowMeSharedBet } from '@core/Areas/FollowMe/types'
import { SharedBetCard } from '../SharedBetCard'
import { NewPostsIndicator } from './Components/NewPostsIndicator'

export const NewFeedPostsManager: React.FC<
  Pick<FollowMeFeedParams, 'fromPostId' | 'sortOrder' | 'sortFilter' | 'isFollowing'>
> = ({ fromPostId, sortOrder, sortFilter, isFollowing = false }) => {
  const [postsToRender, setPostsToRender] = React.useState<FollowMeSharedBet[]>([])
  const [newPosts, setNewPosts] = React.useState<FollowMeSharedBet[]>([])

  const latestSeenPostIdRef = React.useRef(fromPostId)
  const lastFetchMsRef = React.useRef(0)

  React.useEffect(() => {
    const fetchNewPosts = async () => {
      const posts = await getFollowMeSharedBetsFeed({
        fromPostId: latestSeenPostIdRef.current,
        sortOrder,
        sortFilter,
        isFollowing,
      })

      if (posts.length > 0) {
        setNewPosts(posts)
      }
    }

    const handleInteraction = () => {
      const now = Date.now()
      if (now - lastFetchMsRef.current > 20_000) {
        lastFetchMsRef.current = now
        fetchNewPosts()
      }
    }

    window.addEventListener('scroll', handleInteraction)
    return () => window.removeEventListener('scroll', handleInteraction)
  }, [sortOrder, sortFilter, isFollowing])

  const onClick = () => {
    if (!newPosts.length) return

    latestSeenPostIdRef.current = newPosts[0].postId
    setPostsToRender(curr => [...newPosts, ...curr])
    setNewPosts([])

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }, 0)
  }

  return (
    <>
      <NewPostsIndicator newPosts={newPosts} onClick={onClick} />

      {postsToRender.map(post => (
        <SharedBetCard key={post.postId} sharedBet={post} />
      ))}
    </>
  )
}
